"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _user = require("@/api/user");
var _user2 = require("@/api/iot/user");
var _status = require("@/api/iot/status");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _authInfoDialog = _interopRequireDefault(require("@/components/dialogs/authInfoDialog"));
var _userProxy = _interopRequireDefault(require("@/components/dialogs/userProxy"));
var _merchant = require("@/api/merchant");
var _changeScore = _interopRequireDefault(require("./components/changeScore"));
var _default = {
  components: {
    customPage: _customPage.default,
    authInfoDialog: _authInfoDialog.default,
    userProxy: _userProxy.default,
    changeScore: _changeScore.default
  },
  props: ['shopname'],
  data: function data() {
    return {
      loading: false,
      drawerTableShow: false,
      searchForm: {
        nick_name: '',
        cert_name: '',
        mobile: '',
        esign_sign_status: '',
        merchant_id: '',
        cert_rent_state: '',
        is_cert: '',
        is_same_name: 0
      },
      total: 0,
      tableData: [],
      routerName: '',
      editItem: null,
      signStatusList: [],
      drawerData: [],
      merchantList: [],
      certRentList: [{
        id: 1,
        value: 0,
        name: '实名未购买'
      }, {
        id: 2,
        value: 1,
        name: '实名已购买'
      }],
      userCertStatusList: []
    };
  },
  // computed: {
  //   shopname(){
  //     console.log('shopname1',this.$route.query.shopname)
  //   }
  // },
  created: function created() {
    // console.log('shopname1',this.$route.query.shopname)
    if (this.$route.query.shopname) {
      this.routerName = this.$route.query.shopname;
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getEsignSignStatusList();
    this.getUserCertStatusList();
    this.getList();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'memberView') {
      next(function (vm) {
        vm.getList();
      });
    } else {
      next();
    }
  },
  methods: {
    clearAuthInfo: function clearAuthInfo(row) {
      var title = '清除实名';
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u6E05\u9664\u5B9E\u540D\u5417?", "\u6E05\u9664\u5B9E\u540D", {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _user.delMemberUserAuth)({
                  id: row.id
                });
              case 2:
                res = _context.sent;
                console.log(res);
                if (res.status == 1) {
                  console.log('走这儿了');
                  window.location.reload();
                }
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function (err) {});
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context2.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getEsignSignStatusList: function getEsignSignStatusList() {
      var _this = this;
      (0, _status.getEsignSignStatusList)().then(function (res) {
        console.log('getEsignSignStatusList', res);
        if (res) {
          _this.signStatusList = res || [];
        }
      });
    },
    getUserCertStatusList: function getUserCertStatusList() {
      var _this2 = this;
      (0, _status.getUserCertStatusList)().then(function (res) {
        // console.log('getUserCertStatusList', res)
        if (res) {
          _this2.userCertStatusList = res || [];
        }
      });
    },
    getList: function getList(flag) {
      var _this3 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.searchForm.shopname = this.searchForm.shopname || this.routerName;
      this.loading = true;
      (0, _user.getMemberList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this3.loading = false;
        _this3.tableData = res.data || [];
        _this3.total = res.total;
      });
    },
    handleMore: function handleMore(command, item) {
      console.log(command, item);
      // this.selectedItem = item;
      if (command == 'edit') {
        // 编辑资料
        this.$router.push({
          name: 'memberView',
          params: {
            viewId: item.id,
            toEdit: true
          }
        });
      } else {
        // 查看备注
      }
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = {
        shopname: '',
        account_num: '',
        status: null,
        merchant_id: '',
        cert_rent_state: '',
        is_cert: '',
        is_same_name: '',
        cert_name: ''
      };
      this.routerName = '';
      this.getList();
    },
    // 启用/禁用
    enable: function enable(id, endisable) {
      var _this4 = this;
      editSupplier({
        id: id,
        endisable: endisable == 1 ? 2 : 1
      }).then(function (res) {
        _this4.getList(true);
      });
    },
    is_break: function is_break(data) {
      var _this5 = this;
      var type = data.is_black == 0 ? 1 : 0;
      (0, _user.saveMemberBreak)({
        type: type,
        id: data.id
      }).then(function (res) {
        _this5.getList();
      });
    },
    is_black_type: function is_black_type(type) {
      return type == 0 ? 'warning' : 'primary';
    },
    // 用户认证信息
    openAuthInfoDialog: function openAuthInfoDialog() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.editItem = val ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, val), {}, {
        uid: val.id
      }) : null;
      this.$refs.authInfoDialog.dialogVisible = true;
    },
    //设置代理人和分佣信息
    openProxyDialog: function openProxyDialog(val) {
      this.editItem = val || null;
      this.$refs.userProxy.dialogVisible = true;
    },
    // 打开drawer
    openProxyDrawer: function openProxyDrawer() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.editItem = item || null;
      // this.drawerTableShow = true
      this.$router.push({
        name: 'memberProxy',
        query: {
          cert_name: item.cert_name || null
        }
      });
    },
    // 查看合同
    getEsignContract: function getEsignContract(item) {
      var _this6 = this;
      this.loading = true;
      (0, _user2.getEsignContract)({
        flow_id: item.esign_flow_id
      }).then(function (res) {
        // console.log('getEsignContract', res)
        // console.log('res.files.downloadUrl', res.files[0].downloadUrl)
        _this6.loading = false;
        if (res) {
          window.open(res.files[0].downloadUrl);
        }
      }).catch(function (err) {
        return _this6.loading = false;
      });
    },
    // 检测实名状态
    chkUserCertStatusType: function chkUserCertStatusType(status) {
      var type = 'info';
      if (status == 1) {
        type = 'warning';
      } else if (status == 2) {
        type = 'success';
      }
      return type;
    },
    openChangeScore: function openChangeScore(item) {
      this.editItem = item || null;
      this.$refs.changeScore.dialogVisible = true;
    }
  }
};
exports.default = _default;